import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import { Copy, Check, Sparkles } from "lucide-react";
import { toast } from "sonner";
import AiScriptPanel from "../components/AiScriptPanel";

export default function Scripts() {
  const [scripts, setScripts] = useState([]);
  const [copied, setCopied] = useState(null);
  const [aiOpen, setAiOpen] = useState(false);

  useEffect(() => {
    api.get("/content/scripts").then((r) => setScripts(r.data || []));
  }, []);

  const copy = (id, body) => {
    navigator.clipboard.writeText(body);
    setCopied(id);
    toast.success("Copied to clipboard");
    setTimeout(() => setCopied(null), 1500);
  };

  return (
    <div className="space-y-7" data-testid="scripts-page">
      <header className="flex items-end justify-between flex-wrap gap-4">
        <div>
          <div className="overline">Agent Playbook</div>
          <h1 className="font-heading text-5xl mt-2">Scripts & Dialogues</h1>
          <p className="text-sm text-[#050303]/60 mt-2">4 ready-to-use scripts · one-click copy · AI custom generator.</p>
        </div>
        <button
          onClick={() => setAiOpen((o) => !o)}
          className="bg-[#bf858e] text-white pill-btn hover:bg-[#050303] flex items-center gap-2"
          data-testid="ai-generate-toggle"
        >
          <Sparkles size={16} /> AI Script Generator
        </button>
      </header>

      {aiOpen && <AiScriptPanel />}

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        {scripts.map((s) => (
          <ScriptCard key={s.id} script={s} copied={copied === s.id} onCopy={() => copy(s.id, s.body)} />
        ))}
      </div>
    </div>
  );
}

function ScriptCard({ script, copied, onCopy }) {
  return (
    <div className="core-card p-7 flex flex-col" data-testid={`script-${script.id}`}>
      <div className="flex items-start justify-between mb-3">
        <div>
          <div className="overline">{script.category}</div>
          <h3 className="font-heading text-2xl mt-1">{script.title}</h3>
        </div>
        <button
          onClick={onCopy}
          className="border border-[#050303] text-[#050303] hover:bg-[#050303] hover:text-white pill-btn text-xs flex items-center gap-2"
          data-testid={`copy-${script.id}`}
        >
          {copied ? <Check size={13} /> : <Copy size={13} />}
          {copied ? "Copied" : "Copy"}
        </button>
      </div>
      <div className="whitespace-pre-wrap text-sm text-[#050303]/80 leading-relaxed flex-1">{script.body}</div>
    </div>
  );
}
